import React from 'react';
import { Spin } from 'antd';
import type { SpinProps } from 'antd';

type LoadingCardProps = {
  label?: React.ReactNode;
  size?: SpinProps['size'];
  indicator?: SpinProps['indicator'];
  className?: string;
  style?: React.CSSProperties;
};

const LoadingCard: React.FC<LoadingCardProps> = ({
  label,
  size = 'large',
  indicator,
  className,
  style,
}) => {
  const mergedClassName = ['loading-card', className].filter(Boolean).join(' ');

  return (
    <div className={mergedClassName} role="status" aria-live="polite" style={style}>
      <Spin size={size} indicator={indicator} />
      {label ? <span>{label}</span> : null}
    </div>
  );
};

export default LoadingCard;
